module.exports = __webpack_public_path__ + "static/jayjay-0545c6c9541b6889427c286e0b8713ab.png";